import React, { useEffect, useState } from 'react'
import '../styles/Stylers.scss'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import FilterIcon from '../assets/imgs/stylers-images/filter-icon.svg'
import StylerCard from '../Client/Components/Cards/StylerCard'
import { getDataById } from '../apis/generalApis'
import FeaturedStylistCard from '../Client/Components/Cards/FeaturedStylistCard'
import { ScaleLoader } from 'react-spinners'

function Stylers() {
  const user = JSON.parse(localStorage.getItem('user'))
  const [activeTab, setActiveTab] = React.useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [favouriteStylists, setFavouriteStylists] = React.useState([])
  const [clientPastStylists, setClientPastStylists] = React.useState([])
  const [activeSortOption, setActiveSortOption] = React.useState(null)
  const [sortDropdown, setSortDropdown] = React.useState({
    opened: false,
    activeOption: 4,
  })
  useEffect(() => {
    getFavouriteStylists()
  }, [])

  useEffect(() => {
    getClientPastStylists()
  }, [sortDropdown])

  const getFavouriteStylists = async () => {
    try {
      setIsLoading(true)
      let result = await getDataById('show-favorite-stylists', {
        user_id: user?.id,
      })
      setIsLoading(false)
      if (result?.success === true) {
        setFavouriteStylists(result?.data?.stylist)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getClientPastStylists = async () => {
    try {
      let result = await getDataById('past-stylist', {
        client_id: user?.id,
        // month: dropdownOptions[sortDropdown.activeOption].value,
      })
      if (result?.success === true && result?.data != null) {
        setClientPastStylists(result?.data)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const toggleSortDropdown = () => {
    setSortDropdown((previousState) => {
      return { ...previousState, opened: !previousState.opened }
    })
  }
  const dropdownOptions = [
    // { label: 'For How Long?', value: '' },
    { label: '1 Month', value: 1 },
    { label: '3 Months', value: 3 },
    { label: '6 Months', value: 6 },
    { label: '1 Year', value: 12 },
    { label: 'All Time', value: null },
  ]

  return (
    <div className="stylers mb-4">
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100vh',
          top: 0,
          display: 'flex',
          zIndex: 9,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="custom-tabs d-flex flex-wrap justify-content-center justify-content-md-between justify-content-sm-center my-4">
              <div className="d-flex">
                <div
                  className={`tab ${activeTab === 0 ? 'active-tab' : ''}`}
                  onClick={() => setActiveTab(0)}
                >
                  <p className="fs-18 color-primary">Favorite</p>
                </div>
                <div
                  className={`tab ${activeTab === 1 ? 'active-tab' : ''}`}
                  onClick={() => setActiveTab(1)}
                >
                  <p className="fs-18 color-primary">Past</p>
                </div>
              </div>
              {activeTab === 1 && (
                <div className="position-relative pointer mt-3 mt-sm-3 mt-md-0 d-flex align-items-center">
                  <div
                    onClick={toggleSortDropdown}
                    className="sort-dropdown d-flex flex-wrap justify-content-between align-items-center bg-white"
                  >
                    <p className="fs-12 m-0 font-weight-bold">Sort By</p>
                    <p className="m-0 fw-bold d-flex align-items-center gap-1">
                      <span className="mt-1 color-primary">
                        {dropdownOptions[sortDropdown.activeOption].label}
                      </span>
                      <span>
                        <KeyboardArrowDownIcon />
                      </span>
                    </p>
                  </div>
                  {sortDropdown.opened && (
                    <div className="dropdown-content">
                      {dropdownOptions.map((item, index) => (
                        <div
                          key={index}
                          className={`dropdown-option hover-div ${
                            sortDropdown.activeOption === index
                              ? 'active-dropdown-option'
                              : ''
                          }`}
                          onClick={() => {
                            setSortDropdown((prev) => ({
                              ...prev,
                              activeOption: index,
                              opened: false,
                            }))
                          }}
                        >
                          <p className="fs-12">{item.label}</p>
                        </div>
                      ))}
                    </div>
                  )}
                  <div className="filter d-flex align-items-center">
                    <img src={FilterIcon} alt="" className="px-2" height={15} />
                    <h3 className="m-0" style={{ fontSize: '1.2rem' }}>
                      Filters
                    </h3>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {activeTab === 0 && (
          <div className="row mt-0 g-3">
            {favouriteStylists?.map((item, index) => (
              <div className="col-12 col-sm-6 col-md-6 col-lg-4" key={item.id}>
                <FeaturedStylistCard
                  stylist={item}
                  component="stylers-favourites-tab"
                  isFavourite={true}
                  action="remove-favourite"
                  getFavouriteStylists={getFavouriteStylists}
                />
              </div>
            ))}
          </div>
        )}
        {activeTab === 1 && (
          <div className="row mt-0 g-3">
            {clientPastStylists?.map((item, index) => (
              <div className="col-12 col-sm-6 col-md-6 col-lg-4" key={item?.id}>
                <FeaturedStylistCard
                  stylist={item}
                  action={
                    favouriteStylists?.find((el) => el?.id === item?.id)
                      ? 'remove-favourite'
                      : 'add-favourite'
                  }
                  isFavourite={
                    favouriteStylists?.find((el) => el?.id === item?.id)
                      ? true
                      : false
                  }
                  getFavouriteStylists={getFavouriteStylists}
                  getClientPastStylists={getClientPastStylists}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default Stylers
